import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import BrandsSection from './components/BrandsSection';
import ProductsTableSection from './components/ProductsTableSection';
import QualitySection from './components/QualitySection';
import LifeWithUsSection from './components/LifeWithUsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <AboutSection />
      <BrandsSection />
      <ProductsTableSection />
      <QualitySection />
      <LifeWithUsSection />
      <ContactSection />
      <Footer />
      <ChatWidget />
      <Toaster />
    </div>
  );
}

export default App;